/**
 * Pinia Store 入口
 */

import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

const pinia = createPinia()

// 使用持久化插件
pinia.use(piniaPluginPersistedstate)

export default pinia

// 导出所有 Store
// 注: useWebSocketStore 不从这里导出 —— 它牵连整个视讯 WS 协议收发代码 (client + handlers,
// 2000+ 行),一旦被这个桶文件静态 re-export,就会经 main.ts → ./stores 的链路被打进大厅
// 首屏主 chunk。需要用的地方 (均为已懒加载的 /live/* 路由) 请直接
// `import { useWebSocketStore } from '@/stores/modules/websocket'`
export { useUserStore } from './modules/user'
export { useTableStore } from './modules/table'
export { useSettingsStore } from './modules/settings'
export { useLoadingStore } from './modules/loading'
export { useLobbyStore } from './modules/lobby'
